// extracted by mini-css-extract-plugin
export var center = "_4j-2";
export var clickableRow = "_4j-5";
export var expandedRow = "_4j-7";
export var hoverable = "_4j-4";
export var left = "_4j-1";
export var right = "_4j-3";
export var row = "_4j-0";
export var selectedRow = "_4j-6";
export var summaryRow = "_4j-8";